import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'regexp_replace',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      params: { pattern: '', replacement: '' },
      transformInPlace: false,
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION,
  'transformations.params.pattern': {
    required: true,
    validate: (value) => {
      if (!value || value === '') {
        return 'Regex pattern is required';
      }
      try {
        const regex = RegExp(value);
        return '';
      } catch (e) {
        return 'Invalid regular expression';
      }
    },
  },
  'transformations.params.replacement': {
    required: true,
    validate: (value) => {
      if (value === null || value === undefined) {
        return 'Replacement text is required';
      }
      return '';
    },
  },
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CheckBoxField
              checked={transform.transformInPlace}
              onChange={(value) => handleInPlaceChange(index, value)}
              disabled={disableForm}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <SourceColumnField
              helperText={
                errors?.sourceColumns ||
                (transform.transformInPlace
                  ? 'This column will be modified directly'
                  : 'Select text column to transform')
              }
              value={transform.sourceColumns?.[0] || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].sourceColumns = [e.target.value];
                setFieldValue('transformations', newTransforms);
              }}
              headers={headers}
              disabled={disableForm}
              error={!!errors.sourceColumns}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.params?.pattern || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].params = {
                  ...newTransforms[index].params,
                  pattern: e.target.value,
                };
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              label="Regex Pattern *"
              helperText='Regular expression to match "e.g., \\d to replace digits"'
              error={!!errors.params?.pattern}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.params?.replacement || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].params = {
                  ...newTransforms[index].params,
                  replacement: e.target.value,
                };
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              label="Replacement *"
              helperText="Text to replace matches with"
              error={!!errors.params?.replacement}
            />
          </Grid>

          {!transform.transformInPlace && (
            <Grid item {...COMMON_STYLES.gridItem}>
              <OutputColumnField
                value={transform.outputColumn}
                onChange={(e) => {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].outputColumn = e.target.value;
                  setFieldValue('transformations', newTransforms);
                }}
                disabled={disableForm}
                error={!!errors?.outputColumn}
                helperText={errors?.outputColumn || 'Enter output column name'}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  };

  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title="Regex Replace - Replace text using pattern (e.g., 'abc123' with \\d → 'abc')" disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_RegExpReplace = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Regex Replace"
  />
);

export default NodeModal_RegExpReplace;